/* eslint-disable */
import React, { useState } from "react";
import {
  Flex,
  TableContainer,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Box,
  Button,
  FormControl,
  InputGroup,
  Input,
  Textarea,
  Heading,
  Icon,
  Modal,
  SimpleGrid,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components

import { FiArrowLeft } from "react-icons/fi";
import axios from "axios";
import Card from "components/card/Card";
import Information from "./Information";
import { useSelector } from "react-redux";


export default function UsersTable(props) {
  const { kycs, fetchKyc } = props;
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const toast = useToast();
  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isCancelOpen,
    onOpen: onCancelOpen,
    onClose: onCancelClose,
  } = useDisclosure();

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [bvn, setBvn] = useState("");
  const [identity, setIdentity] = useState({});
  const [address, setAddress] = useState({});
  const [kycId, setKycId] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [declineLoading, setDeclineLoading] = useState(false);
  const cardShadow = "md";
  const textColorSecondary = useColorModeValue("secondaryGray.900", "e");
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");

  const getKyc = async (kycId) => {
    try {
      setLoading(true);
      const { data: response } = await axios.get(
        SERVER_URL + "/user/kyc/" + kycId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setFirstName(response.data.firstname);
        setLastName(response.data.lastname);
        setKycId(response.data._id);
        setIdentity(response.data.identity);
        setAddress(response.data.address);
        setBvn(response.data.bvn);
        onOpen();
      }
      setLoading(false);
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  const declineKyc = async () => {
    try {
      setDeclineLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/user/declinekyc/" + kycId,
        { reason: reason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        toast({
          title: response.message,
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        fetchKyc();
        onCancelClose();
        onClose();
      }
      setDeclineLoading(false);
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
    setDeclineLoading(false);
  };

  const processKyc = async () => {
    try {
      setLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/user/processkyc/"+kycId,
        { bvn, address, identity },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setLoading(false);
        toast({
          title: response.message || "An error occured",
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        onClose();
        fetchKyc();
        return;
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>View KYC</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Card mb={{ base: "0px", "2xl": "20px" }}>
              <Text
                color={textColorPrimary}
                fontWeight="bold"
                fontSize="2xl"
                mt="10px"
                mb="4px"
              >
                General Information
              </Text>
              <Text
                color={textColorSecondary}
                fontSize="md"
                me="26px"
                mb="40px"
              >
                Please scrutinize the information below, ensure the name and
                image provided matches the name and image on the ID provided.
                And that the ID is not expired <br />
                Valid forms of Identity remain: <b>Driver License</b>,
                <b>International Passport</b>, <b>NIN</b> and <b>Voters Card</b>
              </Text>
              <SimpleGrid columns="2" gap="20px">
                <Information
                  boxShadow={cardShadow}
                  title="First Name"
                  value={firstname}
                />
                <Information
                  boxShadow={cardShadow}
                  title="Last Name"
                  value={lastname}
                />
              </SimpleGrid>

              <SimpleGrid columns="2" gap="20px" mt="3">
                <Information boxShadow={cardShadow} title="BVN" value={bvn} />
                <Information
                  boxShadow={cardShadow}
                  title="Identity Number"
                  value={identity.idNumber}
                />
              </SimpleGrid>

              <SimpleGrid columns="2" gap="20px" mt="3">
                <Information
                  boxShadow={cardShadow}
                  title="House Number"
                  value={address.houseNumber}
                />
                <Information
                  boxShadow={cardShadow}
                  title="Street"
                  value={address.street}
                />
                <Information
                  boxShadow={cardShadow}
                  title="City"
                  value={address.city}
                />
                <Information
                  boxShadow={cardShadow}
                  title="State"
                  value={address.state}
                />
                <FormControl id="zipcode" isRequired>
                  <InputGroup>
                    <Input
                      type="text"
                      placeholder="Enter Zip Code"
                      maxLength={11}
                      color={textColorSecondary}
                      onChange={(e) => {
                        address["zipcode"] = e.target.value;
                        setAddress(address);
                      }}
                      borderRadius="20"
                    />
                  </InputGroup>
                </FormControl>

                <FormControl id="idnumber" isRequired>
                  <InputGroup>
                    <Input
                      type="text"
                      placeholder="Enter ID Number"
                      defaultValue={identity.idNumber}
                      maxLength={11}
                      color={textColorSecondary}
                      onChange={(e) => {
                        identity.idNumber = e.target.value;
                        setIdentity(identity);
                      }}
                      borderRadius="20"
                    />
                  </InputGroup>
                </FormControl>
              </SimpleGrid>

              <SimpleGrid columns="1" gap="20px" style={{ marginTop: "10px" }}>

                <img
                  src={"http://localhost:4005" + "/" + identity.idImage}
                  style={{ width: "100%;", height: "auto" }} />

              </SimpleGrid>
            </Card>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="red"
              mr={3}
              onClick={() => {
                onCancelOpen();
              }}
            >
              Reject
            </Button>
            <Button
              colorScheme="blue"
              isLoading={loading}
              loadingText="Wait.."
              onClick={() => {
                processKyc();
              }}
            >
              Approve
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isCancelOpen} onClose={onCancelClose} size={"md"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={textColorSecondary}>
            <Icon
              as={FiArrowLeft}
              onClick={onCancelClose}
              width="20px"
              height="20px"
              color="white"
            />
          </ModalHeader>
          <ModalCloseButton color={textColorSecondary} />
          <ModalBody>
            <SimpleGrid>
              <Box mt="4">
                <Heading
                  as="h4"
                  color={textColorSecondary}
                  fontSize={{ base: "xl", lg: "2xl" }}
                >
                  Decline KYC
                </Heading>
              </Box>
              <Box mt="3">
                <Text color={textColorSecondary}>
                  Enter a reason for KYC Decline
                </Text>
              </Box>

              <Box mt="1">
                <FormControl id="reason" isRequired>
                  <Textarea
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                    placeholder="Reason for decline"
                    size="sm"
                    borderRadius="20"
                  />
                </FormControl>
              </Box>

              <Box mt="3">
                <Button
                  variant="primary"
                  color={"white"}
                  isLoading={declineLoading}
                  loadingText={"Processing..."}
                  w="full"
                  borderRadius="20"
                  onClick={(e) => {
                    e.preventDefault();
                    declineKyc();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <Card w="100%" px="0px" overflowY={{ sm: "scroll", lg: "hidden" }}>
        <Flex px="25px" justify="space-between" mb="20px" align="center">
          <Text
            color={textColor}
            fontSize="22px"
            fontWeight="700"
            lineHeight="100%"
          >
            Users Table
          </Text>
        </Flex>

        <TableContainer>
          <Table variant="simple" color="gray.500" mb="24px">
            <Thead>
              <Tr>
                <Th borderColor={borderColor}>User Info</Th>
                <Th borderColor={borderColor}>Email</Th>
                <Th borderColor={borderColor}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {kycs.map((kyc, index) => {
                return (
                  <Tr
                    key={index}
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Td>
                      {kyc.firstname} {kyc.lastname}
                    </Td>
                    <Td>{kyc.user.email}</Td>
                    <Td>
                      {kyc.user.kycStatus == "pending" && (
                        <Button
                          onClick={() => {
                            getKyc(kyc._id);
                          }}
                          isLoading={loading}
                          loadingText="Fetching..."
                        >
                          View Kyc
                        </Button>
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
}
